export default __webpack_public_path__ + "685951b6563d035a09f18348cf4d0301.webp";